import React from "react";
import { v4 as uuidv4 } from "uuid";

import { PlacehodlerFormValues } from "../PagePlaceholdersForm";
import "./HtmlPlaceholderPreview.css";

interface HtmlPlaceholderPreviewProps {
  x: PlacehodlerFormValues;
  fillPlaceholdersBackground?: boolean;
}

export const HtmlPlaceholderPreview = ({ x, fillPlaceholdersBackground }: HtmlPlaceholderPreviewProps) => {
  return (
    <div
      id="html-placeholder-preview"
      style={{
        // color: x.color ?? "",
        backgroundColor: fillPlaceholdersBackground ? "rgba(131,131,131,0.2)" : undefined,
        position: "absolute",
        // fontSize: `${x.fontSize}pt` ?? "20px",
        top: `${+x.top + 2}pt`, // + 2
        left: `${x.left}pt`,
        width: `${x.width}pt`,
        height: `${x.height}pt`,
        // textAlign: textAlignmentOptions[x.textAlignment ?? 1],
        // @ts-ignore
        // ...previewFonts[x.fontFamily ?? ""],
      }}
    >
      <div className="verp-cod" key={uuidv4()} dangerouslySetInnerHTML={{ __html: x.example ?? "" }} />
    </div>
  );
};
